import firebase from '../firebaseConfig';
import Project from './Project';
import { resolveAudioURL } from '../signedURLCache';

class Track {
    constructor(id, currRevId, name, duration, orderWeight, isLocked, project, localURL = null) {
        this.id = id;
        this.currRevId = currRevId;
        this.name = name || "Untitled";
        this.duration = duration;
        this.orderWeight = orderWeight;
        this.isLocked = isLocked;
        this.project = project;
        // In-progress upload: object URL for the local file. Lets the
        // optimistic UI play before the upload completes.
        this.localURL = localURL;
    }

    resolveStreamingURL() {
        if (this.localURL) return Promise.resolve(this.localURL);
        if (!this.project) {
            return Promise.reject(new Error('Track has no project'));
        }
        return resolveAudioURL({
            artistId: this.project.artistId || this.project.artist?.id,
            projectId: this.project.id,
            kind: 'track',
            contentId: this.id,
        });
    }

    static async getTrackById(artistId, projectId, trackId) {
        const dbRef = firebase.database().ref("artists").child(artistId)
            .child("projects").child(projectId).child("tracks").child(trackId);

        const deletedDbRef = firebase.app("deletedData").database().ref("artists").child(artistId)
            .child("projects").child(projectId).child("tracks").child(trackId);

        let snapshot = await dbRef.once("value");
        if (!snapshot.exists()) {
            snapshot = await deletedDbRef.once("value");
        }

        if (!snapshot.exists()) {
            throw new Error("Track not found");
        }

        const track = snapshot.val();
        const metadata = track.metadata;
        const currentRevisionId = metadata["current revision"];
        const currentRevision = track.revisions[currentRevisionId].metadata;

        const project = await Project.getProjectById(artistId, projectId);

        return new Track(
            trackId,
            currentRevisionId,
            metadata.name,
            currentRevision.duration,
            metadata["order weight"],
            metadata["locked"] === true ? true : false,
            project
        );
    }
}

export default Track;
